import { RefObject, useEffect, useState } from "react";
import { useCurrentInputDevice } from "./use-current-input-device";
import { useBrowserTabVisibility } from "./use-browser-tab-visibility";

export const useFocus = (ref: RefObject<HTMLElement>) => {
  const [focused, setFocused] = useState(false);
  const { isKeyboard, setDevice } = useCurrentInputDevice();
  const { isBrowserTabVisible } = useBrowserTabVisibility();

  useEffect(() => {
    const node = ref.current;

    if (!node) {
      return;
    }

    const handleFocusIn = () => {
      setFocused(isKeyboard);
    };

    const handleFocusOut = () => {
      setFocused(false);
    };

    const focusEventName = "focusin";
    const blurEventName = "focusout";

    node.addEventListener(focusEventName, handleFocusIn);
    node.addEventListener(blurEventName, handleFocusOut);

    if (!isKeyboard && focused) {
      handleFocusOut();
    }

    return () => {
      node.removeEventListener(focusEventName, handleFocusIn);
      node.removeEventListener(blurEventName, handleFocusOut);
    };
  }, [isKeyboard, ref]);

  useEffect(() => {
    if (!isBrowserTabVisible) {
      setDevice("mouse");
    }
  }, [isBrowserTabVisible]);

  return { focused };
};
